import axios from 'axios';

export default class PricesIndicusWebserviceSendsService {

	static axiosCancelToken = axios.CancelToken.source();

	static list = (params) => {
		this.newAxiosCancelToken();

		return axios.get('api/prices-indicus-webservice-sends/list', {
			params: {...params},
			cancelToken: this.axiosCancelToken.token
		}).then((response) => {
			return response.data;
		}).catch((error) => {
			if ( axios.isCancel(error) ) return null;
		});
	}
	
	static resend = (id) => {
		this.newAxiosCancelToken();

		return axios.post('api/prices-indicus-webservice-sends/resend/' + id, {}, {
			cancelToken: this.axiosCancelToken.token
		}).then((response) => {
			return response.data;
		}).catch((error) => {
			if ( axios.isCancel(error) ) return null;
			return error.response.data;
		});
	}

	static cancel = () => {
		this.axiosCancelToken.cancel();
	}

	static newAxiosCancelToken = () => {
		this.axiosCancelToken = axios.CancelToken.source();
	}
	
}